import { useSelector } from 'react-redux';

import { SolidCheckCircleIcon, SolidExclamationWarningAlertIcon } from '@tempmee/react-icons';
import logoDarkIcon from '../../../images/logos/logoDarkIcon.svg';
import { colors } from '@tempmee/tailwind';

export const Title = ({ isRegistration, showHeading = true }) => {
  const user = useSelector((state) => state.user.selectedChildOffice);
  const userClassification = user?.workerClassification?.classificationType;
  const latestWorkerClassificationRequest = user?.latestWorkerClassificationRequest;
  const workerClassificationRequest = user?.workerClassificationRequest;

  const getWorkerType = () => {
    let title = 'Not Specified';
    let color = colors.error[500];
    let icon = <SolidExclamationWarningAlertIcon color={colors.error[500]} />;

    if (
      latestWorkerClassificationRequest?.status === 'requested' ||
      (workerClassificationRequest?.length === 1 &&
        workerClassificationRequest?.[0]?.status === 'requested')
    ) {
      title = `Pending Approval / 
      ${
        latestWorkerClassificationRequest?.requestWorkerClassification ??
        workerClassificationRequest?.[0]?.requestWorkerClassification
      }`;
      color = colors.warning[700];
      icon = <SolidExclamationWarningAlertIcon color={colors.warning[700]} />;
    } else if (userClassification) {
      title = userClassification;
      color = colors.success[500];
      icon = (
        <SolidCheckCircleIcon size={22} color={colors.success[500]} />
      );
    }

    return (
      <span
        style={{
          display: 'flex',
          marginLeft: 5,
          fontWeight: 400,
          alignItems: 'center',
          textTransform: 'uppercase',
          color,
          gap: 8,
        }}
      >
        <span>{title}</span>
        {icon}
      </span>
    );
  };

  return (
    <div
      style={{
        maxWidth: 436,
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      {showHeading && isRegistration && (
        <img src={logoDarkIcon} style={{ width: 40 }} alt="logo_dark_icon" />
      )}
      {showHeading && (
        <h1 className="global_font f-dark" style={{ textAlign: 'center', marginBottom: 10 }}>
          Worker Type
          {!isRegistration ? ' Setting' : ''}
        </h1>
      )}

      {!isRegistration && (
        <span
          style={{
            fontSize: 18,
            fontWeight: 700,
            fontFamily: 'Nunito',
            color: colors.neutral[600],
            display: 'flex',
            justifyContent: 'center',
            whiteSpace: 'nowrap',
            gap: 4,
          }}
        >
          Worker Type:
          {getWorkerType()}
        </span>
      )}
    </div>
  );
};
